import { render, staticRenderFns } from "./AddConceptCategoryModal.vue?vue&type=template&id=39aacdc2"
import script from "./AddConceptCategoryModal.vue?vue&type=script&lang=js"
export * from "./AddConceptCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39aacdc2')) {
      api.createRecord('39aacdc2', component.options)
    } else {
      api.reload('39aacdc2', component.options)
    }
    module.hot.accept("./AddConceptCategoryModal.vue?vue&type=template&id=39aacdc2", function () {
      api.rerender('39aacdc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/AddConceptCategoryModal.vue"
export default component.exports